// import mitt from "mitt"

// const eventBus = mitt()
// export default eventBus

import mitt from 'mitt';
export const EventBus = mitt();
